import React from 'react';
import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/AppCenter/home" element={<HomePage />} />
        <Route path="*" element={<Navigate to="/AppCenter/home" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
